import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { CostCenterDataForm } from '../../../app/models/CostCenter';
import CostCenterForm from './forms/CostCenterForm';


interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    costCenter: CostCenterDataForm;
    setCostCenter: (costCenter: CostCenterDataForm) => void;
    errorFields?: any;
}

const CostCenterFormContainer = ({
    fetching,
    action,
    cancel,
    costCenter,
    setCostCenter,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <CostCenterForm
                        costCenterDataForm={costCenter}
                        setCostCenterDataForm={setCostCenter}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default CostCenterFormContainer;
